import { render, staticRenderFns } from "./upload-form.vue?vue&type=template&id=18bead1e&scoped=true&"
import script from "./upload-form.vue?vue&type=script&lang=js&"
export * from "./upload-form.vue?vue&type=script&lang=js&"
import style0 from "./upload-form.vue?vue&type=style&index=0&id=18bead1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bead1e",
  null
  
)

export default component.exports